import React from 'react';
import PropTypes from 'prop-types';

import Anchor from '../Anchor';
import SC from './styles';

const CrossLinkHorizontal = ({ img, text, title, linkText, link }) => (
  <SC.CrossLinkHorizontal>
    <SC.Image src={img.src} alt={img.alt} />

    <SC.Content>
      {title && <SC.Title>{title}</SC.Title>}
      {text && <SC.Description>{text}</SC.Description>}
      {linkText && link && <Anchor href={link}>{linkText}</Anchor>}
    </SC.Content>
  </SC.CrossLinkHorizontal>
);

CrossLinkHorizontal.propTypes = {
  /** Title */
  title: PropTypes.string,
  /** Img object */
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }),
  /** Text description */
  text: PropTypes.string,
  /** Link text */
  linkText: PropTypes.string,
  /** Link url */
  link: PropTypes.string
};

CrossLinkHorizontal.legacyName = ['ux-tout-singtel'];
export default CrossLinkHorizontal;
